import React, { useEffect, useMemo, useState } from 'react';
import './FabricInquiriesDetails.css';
import { useMediaQuery } from '@mantine/hooks';
import Navigation from '../sidebar/Navigation';
import { useNavigate } from 'react-router-dom';
import { createB2BAPI } from '../../../api/Interceptor';
import { BASE_URL } from '../../../api/EndPoints';
import { IconPlus } from '@tabler/icons-react';

const FabricInquiriesDetails = () => {
  const isMobile = useMediaQuery('(max-width: 767px)');
  const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 991px)');
  const [inquiries, setInquiries] = useState([]);
  const navigate = useNavigate();
  const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);

  useEffect(() => {
    fetchFabricData();
  }, [])

  const fetchFabricData = async () => {
    try {
      const res = await B2B_API.get(`fabricInquiry`).json();
      setInquiries(res.response)
    } catch (error) {
      console.error('Error fetching fabricInquiry:', error);
    }
  }

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }

  const handleRowClick = (id) => {
    navigate(`/fabric-MyInquiry?id=${id}`);
  };

  return (
    <div className="view-my-page router-view-container">
      {(!isMobile && !isTablet) && <Navigation />}

      <div className="view-fabric-inquiries-v2 route-view">
        <div className="page-header">
          <div className="page-title">Custom Fabric Inquiries</div>
          <button className="btn btn-primary" style={{ display: "flex", gap: "5px" }} onClick={() => navigate("/fabricInquiry/new")}>
            <i className="far fa-plus m-r-4"></i>
            <IconPlus size={18} /> NEW INQUIRY
          </button>
        </div>
        <section className="resolved m-t-32">
          <div className="section-header">
            <div className="section-title">Your inquiries</div>
            <div
              className="total-number"
              style={{
                backgroundColor: "#8bc53f",
                borderRadius: "50%",
                width: "20px",
                height: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontSize: "14px",
                fontWeight: "600"
              }}
            >{inquiries.length}</div>
          </div>
          <div style={{ width: "100%", overflowX: "auto" }}>
            <div style={{ minWidth: "500px" }}>

              {/* HEADER */}
              <div
                className="thead"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  borderBottom: "1px solid #ddd",
                  fontWeight: 600,
                  fontSize: isMobile ? "12px" : "14px"
                }}
              >
                <div style={{ width: "40%", padding: "10px" }}>Inquiry Details</div>
                <div style={{ width: "30%", padding: "10px" }}>Inquiry Date</div>
                <div style={{ width: "30%", padding: "10px" }}>Status</div>
              </div>

              {/* BODY */}
              <div className="tbody">
                {inquiries.length > 0 ? (
                  inquiries.map((inquiry) => (
                    <div
                      key={inquiry.id}
                      onClick={() => handleRowClick(inquiry?.id)}
                      style={{
                        display: "flex",
                        borderBottom: "1px solid #eee",
                        cursor: "pointer",
                        alignItems: "center",
                        fontSize: isMobile ? "12px" : "14px"
                      }}
                    >
                      {/* DETAILS */}
                      <div
                        style={{
                          width: "40%",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          padding: "10px"
                        }}
                      >
                        <img
                          src={`${BASE_URL.replace("/api", "")}${inquiry.referenceImage}?time=${Date?.now()}`}
                          alt=""
                          style={{
                            width: isMobile ? "40px" : "55px",
                            height: isMobile ? "40px" : "55px",
                            borderRadius: "6px",
                            objectFit: "cover"
                          }}
                        />
                        <div style={{ fontWeight: 500 }}>
                          {inquiry.endUse}
                        </div>
                      </div>

                      {/* DATE */}
                      <div style={{ width: "30%", padding: "10px", color: "#666" }}>
                        {formatDate(inquiry.createdDate)}
                      </div>

                      {/* STATUS */}
                      <div style={{ width: "30%", padding: "10px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                          <div
                            style={{
                              width: "8px",
                              height: "8px",
                              borderRadius: "50%",
                              background: inquiry.isProgress ? "#007bff" : "#28a745"
                            }}
                          />
                          {inquiry.isProgress ? "In Progress" : "Complete"}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div style={{ padding: "20px", textAlign: "center" }}>
                    No Inquiries yet
                  </div>
                )}
              </div>

            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default FabricInquiriesDetails;
